import { CustomAppLayout } from '../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { useRouter } from '../../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../context/useStoreAdmin';

import { Button, Cards, Checkbox, Form, FormField, Input, Link, SegmentedControl, SpaceBetween, StatusIndicator } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import Favorites from '../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { ItemGate } from '../../../../resources/types';
import { addNotification, buildBreadcrumbItems, getCookie, getUrlVersion } from '../../../commons/functions';

export const ConfigGatesPage = () => {
  //const storeAdmin = useStoreAdmin();
  const [gates, setGates] = useState<ItemGate[]>([]);
  const [gate, setGate] = useState<ItemGate | null>(null);

  const { navigate } = useRouter();
  const { parameters, setParameters, menu, data, setData, loading, setLoading } = useGlobalState();

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.split("?")[1]);
      const id = params.get("id");
      if (id)
        handleGetGate(parseInt(id));
      else {
        setGate(null);
      }
      //handleGetEmail(id ? parseInt(id) : 0);
      //else
      //setMailTemplate(undefined);
    };

    window.addEventListener("hashchange", handleHashChange);
    // also trigger once on mount
    handleHashChange();

    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);
  useEffect(() => {

  }, []);


  const handleUpdateGate = async () => { // Make the function async

    try {
      setLoading(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'JWT': getCookie("JWT"),
          'x-routing': '/private/config/gates/update',
        },
        body: JSON.stringify(gate),

      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const dataWeb = await response.json();
      if (dataWeb.code == 0 && dataWeb.gates) {
        setData((prevData: any) => ({
          ...prevData,        // Keep all other properties (e.g., users, statuses, airports)
          gates: dataWeb.gates // Overwrite only the gates array
        }));

        window.location.hash = "#config/gates";
        addNotification(dataWeb.status, 'success', setData);
      } else {
        addNotification(dataWeb.status, 'error', setData);
      }
    } catch (error: any) {
      addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
    } finally {
      setLoading(false)
    }
  };
  const handleGetGate = async (id: number) => { // Make the function async

    try {
      setLoading(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'JWT': getCookie("JWT"),
          'x-routing': '/private/config/gates/get',
        },
        body: JSON.stringify({ idGate: id }),

      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const dataWeb = await response.json();
      if (dataWeb.code == 0) {
        setGate(dataWeb.gate);
      } else {
        addNotification(dataWeb.status, 'error', setData);
      }
    } catch (error: any) {
      addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
    } finally {
      setLoading(false)
    }
  };

  return (
    <CustomAppLayout
      toolsHide={true}
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <SpaceBetween size="s">
          <Header variant="h1" actions={<Favorites />}>{`Puertas ${gate ? gate.gate : ''}`}</Header>
          {gate && (
            <Form actions={
              <SpaceBetween size="m" direction='horizontal'>
                <Button variant="link" onClick={() => { window.location.hash = "#config/gates"; }}>Cancelar</Button>
                <Button variant="primary" onClick={() => {
                  console.log(gate)
                  handleUpdateGate();
                }}>Actualizar</Button>
              </SpaceBetween>}>

              <SpaceBetween size="m" direction='vertical'>
                <div style={{ width: 200 }}>
                  <FormField label="Número de puerta">
                    <Input value={gate.gate} onChange={e => {
                      setGate({ ...gate!, gate: e.detail.value });
                    }} />
                  </FormField>
                </div>
                <SegmentedControl selectedId={gate.hub} onChange={e => {
                  setGate({ ...gate!, hub: e.detail.selectedId });
                }}
                  options={[
                    { id: "NAC", text: "Nacional" },
                    { id: "INT", text: "Internacional" },
                    { id: "BOTH", text: "Ambos" },
                  ]}
                />
                <Checkbox checked={gate.isActiveGate === 1} onChange={e => {
                  setGate({ ...gate!, isActiveGate: e.detail.checked ? 1 : 0 });
                }}>Activo</Checkbox>
                <div style={{ width: 200 }}>
                  <FormField label="TAG RMS" constraintText="ID utilizado en el sistema RMS">
                    <Input value={gate.AODBTAG} onChange={e => {
                      setGate({ ...gate!, AODBTAG: e.detail.value });
                    }} />
                  </FormField>
                </div>
              </SpaceBetween>
            </Form>
          )}
          {!gate && (
            <Cards
              key="gates-cards"
              cardDefinition={{
                header: item => (
                  <Link href={`#config/gates?id=${item.idGate}`} fontSize="heading-m">Puerta {item.gate}</Link>
                ),
                sections: [
                  {
                    id: "idGate",
                    header: "ID",
                    content: item => item.idGate,
                    width: 50
                  },
                  {
                    id: "isActive",
                    header: "Estado",
                    content: item => item.isActiveGate === 1 ? <StatusIndicator type="success">Activo</StatusIndicator> : <StatusIndicator type="error">Inactivo</StatusIndicator>,
                    width: 50
                  },
                  {
                    id: "hub",
                    header: "Función",
                    content: item => item.hub === "BOTH" ? "Nacional e internacional" : item.hub === "NAC" ? "Nacional" : "Internacional",
                  },
                ]
              }}
              cardsPerRow={[
                { cards: 1 },
                { minWidth: 500, cards: 3 }
              ]}
              items={(data.gates || []) as ItemGate[]}
              trackBy="idGate"
            />
          )}
        </SpaceBetween>
      }
    />
  )
};
